export const alertStatuses = [
  "In progress",
  "Auto-refunded",
  "Manually refunded",
  "Attention",
  "Expired",
  "Lost", // Removed
  "Canceled",
  "Declined",
  "Not found",
  "Error",
  "Failed transaction",
  "Previously refunded",
  "Already a chargeback",
  "Duplicate",
  "Pending"
]

export const alertStatusColorMap = {
  "In progress": "#661AC6",
  "Auto-refunded": "#35BD29",
  "Manually refunded": "#35BD29",
  Attention: "#df7009",
  Expired: "#d71313",
  Lost: "#d71313", // Removed
  Canceled: "#7A7A83",
  Declined: "#d71313",
  "Not found": "#7A7A83",
  Error: "#d71313",
  "Failed transaction": "#d71313",
  "Previously refunded": "#35BD29",
  "Already a chargeback": "#440f0e",
  Duplicate: "#d0d0d4",
  Pending: "#661AC6",
  default: "#7A7A83"
}

export const alertStatusTextMap = {
  "In progress": "In Progress",
  "Auto-refunded": "Auto-Refunded",
  "Manually refunded": "Manually Refunded",
  Attention: "Attention",
  Lost: "Lost", // Removed
  Expired: "Expired",
  Canceled: "Canceled",
  Declined: "Declined",
  "Not found": "Not Found",
  Error: "Error",
  "Failed transaction": "Failed Transaction",
  "Previously refunded": "Previously Refunded",
  "Already a chargeback": "Already a Chargeback",
  Duplicate: "Duplicate",
  Pending: "Pending"
}

export const attentionResolveOptions = [
  "Manually refunded",
  "Declined",
  "Not found",
  "Previously refunded",
  "Already a chargeback",
  "Failed transaction",
];
